export type SurgeryStageOption = {
  value: string;
  label: string;
};

export const SURGERY_STAGE_OPTIONS: SurgeryStageOption[] = [
  { value: "preop", label: "Pre-op" },
  { value: "postop", label: "Post-op" },
  { value: "intraop", label: "Intra-op" },
  { value: "markings", label: "Markings" },
  { value: "wish", label: "Wish" },
];

export const formatSurgeryStageLabel = (stage?: string | null): string => {
  return (
    SURGERY_STAGE_OPTIONS.find((option) => option.value === stage)?.label || ""
  );
};
